import { createSelector } from '@ngrx/store';

import { FeasibilityEstimate } from '@ps/survey-utils';

import { surveyCreationFeature } from '../survey-creation.feature';

const { selectInsights } = surveyCreationFeature;

//SECTION SCORE
export const selectScorePercentage = createSelector(
  selectInsights,
  ({ score }) => score.scorePercentage,
);

export const selectScoreLoading = createSelector(
  selectInsights,
  ({ score }) => score.loading,
);

export const selectScoreError = createSelector(
  selectInsights,
  ({ score }) => score.error,
);
//!SECTION

//SECTION FEASIBILITY
export const selectFeasibilityLoading = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.loading,
);

export const selectFeasibilityError = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.error,
);

export const selectFeasibility = createSelector(
  selectInsights,
  ({ feasibility }): FeasibilityEstimate => ({
    total: feasibility.total,
    audience: feasibility.audience,
    quotaGroups: feasibility.quotaGroups,
    cpi: feasibility.cpi,
    suppliers: feasibility.suppliers,
  }),
);

export const selectAdvancedFiltersLookup = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.advancedFiltersLookup,
);

export const selectFeasibilityCpi = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.cpi,
);

export const selectFeasibilitySuppliers = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.suppliers,
);
//!SECTION

//SECTION FLEXIBILITY PRICES
export const selectFlexibilityPrices = createSelector(
  selectInsights,
  ({ flexibilityPrices }) => flexibilityPrices.prices,
);

export const selectFlexibilityPricesError = createSelector(
  selectInsights,
  ({ flexibilityPrices }) => flexibilityPrices.error,
);
//!SECTION

//SECTION PRICING
export const selectPricing = createSelector(
  selectInsights,
  ({ pricing }) => pricing,
);
//!SECTION

//SECTION SIMILAR SURVEYS
export const selectSimilarSurveysState = createSelector(
  selectInsights,
  ({ similarSurveys }) => similarSurveys,
);

export const selectSimilarSurveys = createSelector(
  selectSimilarSurveysState,
  ({ surveys }) => surveys,
);

export const selectSimilarSurveysStatus = createSelector(
  selectSimilarSurveysState,
  ({ status }) => status,
);

export const selectSimilarSurveysError = createSelector(
  selectSimilarSurveysState,
  ({ error }) => error,
);

export const selectSimilarSurveysStale = createSelector(
  selectSimilarSurveysState,
  ({ isStale }) => isStale,
);

export const selectSimilarSurveysSearchedTargetingKey = createSelector(
  selectSimilarSurveysState,
  ({ searchedTargetingKey }) => searchedTargetingKey,
);

export const selectSimilarSurveysHasSearched = createSelector(
  selectSimilarSurveysSearchedTargetingKey,
  (searchedTargetingKey) => !!searchedTargetingKey,
);

export const selectSimilarSurveysSearchedGlobally = createSelector(
  selectSimilarSurveysState,
  ({ searchedGlobally }) => searchedGlobally,
);

export const selectSimilarSurveysGlobalSearchUsed = createSelector(
  selectSimilarSurveysState,
  ({ globalSearchUsed }) => globalSearchUsed,
);
//!SECTION
